import React from 'react';
import styles from './feedback-loading.css';
import classnames from 'classnames';

class FeedbackLoading extends React.Component {
    constructor() {
        super()
    }
    render() {
        return <div>
            <div>
                <div className={styles.skWave}>
                    <div className={classnames(styles.skRect,styles.skRect1)}></div>
                    <div className={classnames(styles.skRect,styles.skRect2)}></div>
                    <div className={classnames(styles.skRect,styles.skRect3)}></div>
                    <div className={classnames(styles.skRect,styles.skRect4)}></div>
                    <div className={classnames(styles.skRect,styles.skRect5)}></div>
                </div>
            </div>
        </div>
    }
}

export default FeedbackLoading